<template>
  <v-container>
    <v-row>
      <v-col cols="12" md="12">
        <h2>
          {{ $t('common:emergency') }}
        </h2>

        <v-container class="emergency-border">
          <v-row>
            <v-col cols="12" md="6">
              <MediaContainer
                :gallery="gallery"
                :elevator="emergency.elevator"
                @imageRequest="imageRequest"
              />

              <v-container>
                <h2>{{ $t('common:contact_plural') }}</h2>
                <div class="contact-item"
                     v-for="contact in contacts"
                     :key="contact.key"
                >
                  {{ contact.number }}
                </div>
              </v-container>
            </v-col>
            <v-col cols="12" md="6">
              <v-container>
                <v-row>
                  <v-col>
                    <v-col class="log-container">
                      <v-row>
                        <v-col>
                          <b>{{ $t('components:emergency.started-at') }}: {{ emergency.emergencyStart }}</b>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col>
                          <div class="comment-item">
                            <b>{{ $t('common:comment_plural') }}: </b>
                          </div>
                          <v-col
                            v-for="comment in comments"
                            :key="comment.commentId"
                            class="comment-item"
                          >
                            {{comment.createdAt}}: {{comment.comment}}
                          </v-col>

                          <div class="comment-item">
                            <b>{{ $t('common:answer_plural') }}: </b>
                          </div>
                          <v-col
                            v-for="answer in answers"
                            :key="answer.answerId"
                            class="comment-item"
                          >
                            {{answer.msgTime}}: {{answer.message}}
                          </v-col>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col>
                          <b>{{ $t('components:emergency.closed-at') }}: {{ emergency.emergencyStop }}</b>
                        </v-col>
                      </v-row>
                    </v-col>

                    <v-textarea
                      outlined
                      v-model="comment"
                      :label="$t('common:comment')"
                      auto-grow
                    />
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <TwoButtonDialog
                        v-if="!emergency.status"
                        ref="closeButton"
                        :btn-text="$t('buttons:close')"
                        color="primary"
                        outlined
                        :rounded="false"
                        :hideOverlay="true"
                        :dialog-title="$t('components:emergency.close-emergency')"
                        :dialog-text="$t('components:emergency.close-emergency-text')"
                        :button1-text="$t('buttons:yes')"
                        :button2-text="$t('buttons:cancel')"
                        @clickedButton1="closeEmergency()"
                        @clickedButton2="$refs.closeButton.showDialog = false"
                    />
                  </v-col>
                  <v-col>
                    <v-btn
                      @click="addComment"
                      outlined
                      class="float-md-right"
                      color="primary"
                    >{{ $t('buttons:add-specific', { specific: $t('common:comment')}) }}</v-btn>
                  </v-col>
                </v-row>
              </v-container>
            </v-col>
          </v-row>
        </v-container>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>

import EmergencyService from '@/modules/display/services/emergency-service';
import MediaContainer from '@/modules/display/views/emergency/hot-emergency/MediaContainer';
import TwoButtonDialog from '@/modules/core/components/TwoButtonDialog/TwoButtonDialog';

export default {
  name: "HotEmergency",
  components: {MediaContainer, TwoButtonDialog},
  data() {
    return {
      comment: '',
      emergency: {},
      comments: [],
      answers: [],
      contacts: [],
      gallery: [],
      galleryImageInterval: null
    }
  },
  methods: {
    loadComments(id, token) {
      EmergencyService.getComments(
        id,
        token,
        (response) => {
          if (this.comments.length === response.data.length) return;

          this.comments = response.data;
          for (let i = 0; i < this.comments.length; i++) {
            this.comments[i].commentId = 'comment' + i;
          }
        }
      );
    },
    loadAnswers(id, token) {
      EmergencyService.getAnswers(
        id,
        token,
        (response) => {
          this.answers = response.data;
          for (let i = 0; i < this.answers.length; i++) {
            this.answers[i].answerId = 'answer' + i;
          }
        }
      )
    },
    loadGallery(id, token) {
      EmergencyService.getGallery(
        id,
        token,
        (response) => {
          if (this.gallery.length === response.data.length) return;
          this.gallery = response.data;

          if (this.galleryImageInterval !== null) {
            clearInterval(this.galleryImageInterval);
            this.galleryImageInterval = null;
          }
        }
      );
    },
    loadEmergency(id, token) {
      EmergencyService.getEmergency(
        id,
        token,
        (response) => {
          this.emergency = response.data;

          let contacts = this.emergency.elevator.emergencyContactList;
          this.contacts = [];

          for (let i = 0; i < contacts.length; i++) {
            this.contacts.push({key: i, number: contacts[i]});
          }

          this.loadComments(id, token);
          this.loadAnswers(id, token);
          this.loadGallery(this.emergency.elevator.id, token);
          setInterval(this.loadComments, 5000, id, token);
        },
        () => {
          this.$router.push('/display/elevator');
        }
      );
    },

    addComment() {
      if (!this.comment) return;
      let emergencyId = this.$route.params.id;
      let optTocken = this.$route.query.otptoken;
      EmergencyService.addComment(
        emergencyId,
        optTocken,
        this.comment,
        (response) => {
          this.comments.push(response.data);
          this.comment = '';
        }
      )
    },

    closeEmergency() {
      let emergencyId = this.$route.params.id;
      let optTocken = this.$route.query.otptoken;
      EmergencyService.closeEmergency(
        emergencyId,
        optTocken,
        () => {
          this.loadEmergency(emergencyId, optTocken);
        }
      )
    },

    imageRequest() {
      let emergencyId = this.$route.params.id;
      let optTocken = this.$route.query.otptoken;

      EmergencyService.imageRequest(
        emergencyId,
        optTocken,
        this.emergency.elevator.id,
        (response) => {
          this.comments.push(response.data);
          this.galleryImageInterval = setInterval(this.loadGallery, 5000, this.emergency.elevator.id, optTocken);
        }
      )
    }
  },
  created() {
    let emergencyId = this.$route.params.id;
    let optTocken = this.$route.query.otptoken;
    this.loadEmergency(emergencyId, optTocken);
  }
}
</script>

<style>
.log-container {
  border: 1px solid grey;
  border-radius: 4px;
  margin-bottom: 20px;
}

.emergency-border {
  background-color: #fff;
}

.comment-item {
  margin: 0;
  padding: 0;
}

.contact-item {
  padding: 10px 5px;
  border: 1px solid grey;
  border-radius: 4px;
  margin: 10px 0;
}
</style>